const findArrayDuplicates = (array, attribute) => {
  const counts = array.reduce((acc, item) => {
    const key = item[attribute];
    if (key !== undefined) {
      acc[key] = (acc[key] || 0) + 1;
    }
    return acc;
  }, {});

  return array.filter(item => counts[item[attribute]] > 1);
};

export default findArrayDuplicates;